const Accessibility = () => {
    const body = document.body;
    const root = document.documentElement;

    const FONT_STEP = 0.1;
    const FONT_MIN = -3;
    const FONT_MAX = 3;

    const READABLE_LETTER_SPACING = '0.5px';

    let fontLevel = Number(localStorage.getItem('fontLevel')) || 0;
    let fontScale = 1 + (fontLevel * FONT_STEP);

    const init = () => {
        restoreSettings();
        bindContrast();
        bindLayout();
        bindFont();
    };

    const restoreSettings = () => {
        const contrast = localStorage.getItem('contrast');

        if (contrast && contrast !== 'default') {
            body.classList.add(`contrast-${contrast}`);
        }

        setActive('[data-contrast]', contrast || 'default');

        const layout = localStorage.getItem('layout');

        if (layout) {
            body.classList.add(`layout-${layout}`);
        }

        setActive('[data-layout]', layout || 'wide');

        const readableFont = localStorage.getItem('readableFont') === 'true';

        if (readableFont) {
            body.classList.add('readable-font');
        }

        root.style.setProperty('--font-scale', fontScale);
        root.style.setProperty(
            '--letter-spacing',
            readableFont ? READABLE_LETTER_SPACING : '0px'
        );
    };

    const bindContrast = () => {
        document.querySelectorAll('[data-contrast]').forEach(button => {
            button.addEventListener('click', () => {
                body.classList.remove(
                    'contrast-dark',
                    'contrast-bw',
                    'contrast-by',
                    'contrast-yb'
                );

                const value = button.dataset.contrast;

                if (value !== 'default') {
                    body.classList.add(`contrast-${value}`);
                }

                localStorage.setItem('contrast', value);

                setActive('[data-contrast]', value);
            });
        });
    };

    const bindLayout = () => {
        document.querySelectorAll('[data-layout]').forEach(button => {
            button.addEventListener('click', () => {
                body.classList.remove('layout-boxed', 'layout-wide');

                const value = button.dataset.layout;

                body.classList.add(`layout-${value}`);

                localStorage.setItem('layout', value);

                setActive('[data-layout]', value);
            });
        });
    };

    const bindFont = () => {
        document.querySelectorAll('[data-font]').forEach(button => {
            button.addEventListener('click', () => {
                switch (button.dataset.font) {

                    case 'larger':
                        if (fontLevel < FONT_MAX) {
                            fontLevel++;
                        }
                        break;

                    case 'smaller':
                        if (fontLevel > FONT_MIN) {
                            fontLevel--;
                        }
                        break;

                    case 'reset':
                        fontLevel = 0;

                        body.classList.remove('readable-font');

                        root.style.setProperty('--letter-spacing', '0px');

                        localStorage.removeItem('readableFont');
                        break;

                    case 'readable':
                        body.classList.toggle('readable-font');

                        const readableFont = body.classList.contains('readable-font');

                        root.style.setProperty(
                            '--letter-spacing',
                            readableFont ? READABLE_LETTER_SPACING : '0px'
                        );

                        localStorage.setItem('readableFont', readableFont);

                        return;
                }

                fontScale = 1 + (fontLevel * FONT_STEP);

                root.style.setProperty('--font-scale', fontScale);

                localStorage.setItem('fontLevel', fontLevel);
                localStorage.setItem('fontScale', fontScale);
            });
        });
    };

    const setActive = (selector, value) => {
        document.querySelectorAll(selector).forEach(button => {
            const key = selector === '[data-layout]' ? 'layout' : 'contrast';

            button.classList.toggle('is-active', button.dataset[key] === value);
        });
    };

    init();
};

export default Accessibility;